import React, { useState } from "react";
import styled from "styled-components";

const CollapsablePanelDiv = styled.div`
  display: flex;
  flex: 1 1 100%;
  padding: 0.25em px 0px 1.15em;
  .panel {
    display: flex;
    flex-direction: column;
    flex: 1 1 100%;
  }
`;

const Title = styled.div`
  padding: 10px 15px;
  cursor: pointer;

  .collapsed-arrow {
    &::after {
      font-family: "Glyphicons Halflings";
      font-size: 0.8em;
      content: "\e113";
      float: right;
      margin-left: 15px;
      transition: all 0.4s;
    }
  }

  .uncollapsed {
    &::after {
      transform: rotate(180deg);
    }
  }

  .collapsed {
    &::after {
      transform: rotate(0deg);
    }
  }
`;

const Panel = styled.div`
  padding: 15px;
  display: ${({ collaps }) => (collaps ? "block" : "none")};
`;

const CollapsablePanel = ({
  title,
  children,
  expanded = false,
  className = "",
}) => {
  const [collaps, setCollaps] = useState(expanded);
  const titleClassName = collaps === true ? "uncollapsed" : "collapsed";

  const handleClick = () => {
    setCollaps(!collaps);
  };

  return (
    <CollapsablePanelDiv className={`panel-group ${className} margin-b-0`}>
      <div className="panel panel-default">
        <div className="panel-heading">
          <h4 className="panel-title font-size-14">
            <Title
              className={`collapsed-arrow ${titleClassName}`}
              onClick={handleClick}
            >
              {title}
            </Title>
          </h4>
        </div>
        <Panel collaps={collaps}>{children}</Panel>
      </div>
    </CollapsablePanelDiv>
  );
};

export default CollapsablePanel;
